import { postJSON, put, remove, get } from "api/base";
import type { S3IntegrationData } from "pages/organization/components/integrations/integrations.types";
import type { CredentialType } from "./integrations.types";

const SOCIAL_CREDENTIAL_ENDPOINT = `v1/account/social-credentials`;

/**
 * @function Add AWS credentials for S3 for the current user
 * @param data - Account details
 */
export async function addS3Account(data: S3IntegrationData) {
    return await postJSON(`${SOCIAL_CREDENTIAL_ENDPOINT}/s3`, data);
}

/**
 * @function Tests S3 connection given an S3UserSocialCredentialRequest
 * @param data - Account details
 */
export async function s3TestConnection(data: S3IntegrationData) {
    return await postJSON(`${SOCIAL_CREDENTIAL_ENDPOINT}/s3/connection`, data);
}

export const shareToSocialMediaEndPoint = (
    data: {
        type: CredentialType;
        userSocialCredentialId: string;
        title: string;
    },
    id: string
) => postJSON(`v1/shares/${id}/social-media`, data);

/**
 * @function updateCredentialStatus stores the selected state of a credential in the share sidebar
 * @param id of the social credential to update
 */
export const updateCredentialStatus = async (id: string) => {
    return await put(`${SOCIAL_CREDENTIAL_ENDPOINT}/${id}/status`);
};

/**
 * @function Toggles all the credentials, used for deselecting all credentials supplied
 * @param socialIds comma seperated list of socialIds
 */
export const toggleMultipleCredentialsStatus = async (socialIds: string) => {
    return await put(`${SOCIAL_CREDENTIAL_ENDPOINT}/toggle`, { socialIds });
};

/**
 * @function Deletes the given social credential
 * @param socialId of the social credential to delete
 */
export const deleteCredential = async (socialId: string) => {
    return await remove(`${SOCIAL_CREDENTIAL_ENDPOINT}/${socialId}`);
};

/**
 * @function Returns the social credentials for the current user, without paging at this point
 * @returns returns an array of social credential models
 */
export const getUserCredentials = async (): Promise<unknown[]> => {
    //TODO: the return type of this can be an array of many different things, see user-credentials.store.js
    const {
        data: { data }
    } = await get(`${SOCIAL_CREDENTIAL_ENDPOINT}`);
    return data;
};
